import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "../facility/facility.scss";

import Page from "components/page/Page";
import { StatusCode } from "api/protocols";

import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import "./departments.scss";
import { GetDepartments } from "api/rpc/2024-04/facilityAdmin/facility/department";
import { useAppSelector } from "hooks/redux";

export default function Departments() {
  const history = useHistory();
  const { t } = useTranslation();
  const { authStore, facilityStore } = useAppSelector(store => store);
  const canEditDepartment =
    !!authStore?.user?.permissions?.departments_edit && !!facilityStore?.facility?.permissions?.departments_edit;

  const [departmentState, setDepartmentTypeState] = useState({
    department: null,
  });

  const chevronUp: IconProp = ["far", "chevron-up"];
  const chevronDown: IconProp = ["far", "chevron-down"];

  useEffect(() => {
    void loadDepartments();

    return () => {
      setDepartmentTypeState({ department: null });
    };
  }, []);

  async function loadDepartments() {
    const res = await GetDepartments({ extended: true }, true);
    if (res.status !== StatusCode.OK) {
      return;
    }

    const departments = res.data;

    {
      departments
        ?.filter((filteredDepart: any) => filteredDepart.type === "department")
        .map((department: any) => {
          department.selected = true;

          if (department.cateogries.length > 0) {
            department.cateogries.map((category: any) => {
              category.selected = true;
            });
          }
        });
    }

    setDepartmentTypeState(prev => ({
      ...prev,
      department: departments,
    }));
  }

  function navigateToEditDepartment(url: string) {
    history.push(url);
  }

  function handleDepartmentSelect(department: any, category?: any) {
    const departments = departmentState.department;

    if (category === null || category === undefined) {
      {
        departments
          ?.filter((filteredDepart: any) => filteredDepart.id === department.id)
          .map((department: any) => {
            department.selected = !department.selected;
          });
      }

      setDepartmentTypeState(prev => ({
        ...prev,
        department: departments,
      }));
    } else {
      {
        departments
          ?.filter((filteredDepart: any) => filteredDepart.id === department.id)
          .map((department: any) => {
            department.cateogries
              ?.filter((filteredCategory: any) => filteredCategory.id === category.id)
              .map((category: any) => {
                category.selected = !category.selected;
              });
          });
      }

      setDepartmentTypeState(prev => ({
        ...prev,
        department: departments,
      }));
    }
  }

  return (
    <Page
      title={t("Departments & categories")}
      subtitle={t("Manage departments, categories and subcategories for products")}
      multipleActionDropdownAction={{
        label: t("Add new"),
        dropdownProps: {
          alignment: "right",
          options: [
            {
              type: "handler",
              label: t("Department"),
              handler: () => history.push("/admin/settings/departments/department/new"),
              icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="9" viewBox="0 0 15 9" fill="none">
                  <path
                    d="M7.65518 0.829912C7.56773 0.786185 7.524 0.764321 7.47813 0.755716C7.43751 0.748095 7.39582 0.748095 7.3552 0.755716C7.30933 0.764321 7.26561 0.786185 7.17815 0.829912L0.75 4.04399L7.17815 7.25806C7.26561 7.30179 7.30933 7.32366 7.3552 7.33226C7.39582 7.33988 7.43751 7.33988 7.47813 7.33226C7.524 7.32366 7.56773 7.30179 7.65518 7.25806L14.0833 4.04399L7.65518 0.829912Z"
                    stroke="#344054"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              disabled:
                !authStore?.user?.permissions?.departments_create ||
                !facilityStore?.facility?.permissions?.departments_create,
            },
            {
              type: "handler",
              label: t("Category"),
              handler: () => history.push("/admin/settings/departments/category/new"),
              icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" fill="none">
                  <path
                    d="M0.75 7.37732L7.17815 10.5914C7.26561 10.6351 7.30933 10.657 7.3552 10.6656C7.39582 10.6732 7.43751 10.6732 7.47813 10.6656C7.524 10.657 7.56773 10.6351 7.65518 10.5914L14.0833 7.37732M0.75 4.04399L7.17815 0.829912C7.26561 0.786185 7.30933 0.764321 7.3552 0.755716C7.39582 0.748095 7.43751 0.748095 7.47813 0.755716C7.524 0.764321 7.56773 0.786185 7.65518 0.829912L14.0833 4.04399L7.65518 7.25807C7.56773 7.30179 7.524 7.32366 7.47813 7.33226C7.43751 7.33988 7.39582 7.33988 7.3552 7.33226C7.30933 7.32366 7.26561 7.30179 7.17815 7.25807L0.75 4.04399Z"
                    stroke="#344054"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              disabled:
                !authStore?.user?.permissions?.departments_create ||
                !facilityStore?.facility?.permissions?.departments_create,
            },

            {
              type: "handler",
              label: t("Subcategory"),
              handler: () => history.push("/admin/settings/departments/subcategory/new"),
              icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                  <path
                    d="M0.75 7.37732L7.17815 10.5914C7.26561 10.6351 7.30933 10.657 7.3552 10.6656C7.39582 10.6732 7.43751 10.6732 7.47813 10.6656C7.524 10.657 7.56773 10.6351 7.65518 10.5914L14.0833 7.37732M0.75 10.7107L7.17815 13.9247C7.26561 13.9685 7.30933 13.9903 7.3552 13.9989C7.39582 14.0065 7.43751 14.0065 7.47813 13.9989C7.524 13.9903 7.56773 13.9685 7.65518 13.9247L14.0833 10.7107M0.75 4.04399L7.17815 0.829912C7.26561 0.786185 7.30933 0.764321 7.3552 0.755716C7.39582 0.748095 7.43751 0.748095 7.47813 0.755716C7.524 0.764321 7.56773 0.786185 7.65518 0.829912L14.0833 4.04399L7.65518 7.25806C7.56773 7.30179 7.524 7.32366 7.47813 7.33226C7.43751 7.33988 7.39582 7.33988 7.3552 7.33226C7.30933 7.32366 7.26561 7.30179 7.17815 7.25806L0.75 4.04399Z"
                    stroke="#344054"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              disabled:
                !authStore?.user?.permissions?.departments_create ||
                !facilityStore?.facility?.permissions?.departments_create,
            },
          ],
        },
      }}
      breadcrumbs={[
        { label: t("Settings"), url: "/admin/settings" },
        { label: t("Departments & categories"), url: "/admin/settings/departments" },
      ]}
    >
      <hr />

      <div className="departments-container mt-4">
        {/* Map through departments */}
        {departmentState.department
          ?.filter((filteredDepart: any) => filteredDepart.type === "department")
          .map((department: any, index: number) => {
            return (
              <React.Fragment key={index}>
                <div key={index} className="department-card">
                  <div className="flex items-center gap-8">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 15 15" fill="none">
                      <path
                        d="M7.50016 2.50065C7.9604 2.50065 8.3335 2.12755 8.3335 1.66732C8.3335 1.20708 7.9604 0.833984 7.50016 0.833984C7.03993 0.833984 6.66683 1.20708 6.66683 1.66732C6.66683 2.12755 7.03993 2.50065 7.50016 2.50065Z"
                        stroke="#344054"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.50016 8.33398C7.9604 8.33398 8.3335 7.96089 8.3335 7.50065C8.3335 7.04041 7.9604 6.66732 7.50016 6.66732C7.03993 6.66732 6.66683 7.04041 6.66683 7.50065C6.66683 7.96089 7.03993 8.33398 7.50016 8.33398Z"
                        stroke="#344054"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.50016 14.1673C7.9604 14.1673 8.3335 13.7942 8.3335 13.334C8.3335 12.8737 7.9604 12.5007 7.50016 12.5007C7.03993 12.5007 6.66683 12.8737 6.66683 13.334C6.66683 13.7942 7.03993 14.1673 7.50016 14.1673Z"
                        stroke="#344054"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.3335 2.50065C13.7937 2.50065 14.1668 2.12755 14.1668 1.66732C14.1668 1.20708 13.7937 0.833984 13.3335 0.833984C12.8733 0.833984 12.5002 1.20708 12.5002 1.66732C12.5002 2.12755 12.8733 2.50065 13.3335 2.50065Z"
                        stroke="#344054"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.3335 8.33398C13.7937 8.33398 14.1668 7.96089 14.1668 7.50065C14.1668 7.04041 13.7937 6.66732 13.3335 6.66732C12.8733 6.66732 12.5002 7.04041 12.5002 7.50065C12.5002 7.96089 12.8733 8.33398 13.3335 8.33398Z"
                        stroke="#344054"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.3335 14.1673C13.7937 14.1673 14.1668 13.7942 14.1668 13.334C14.1668 12.8737 13.7937 12.5007 13.3335 12.5007C12.8733 12.5007 12.5002 12.8737 12.5002 13.334C12.5002 13.7942 12.8733 14.1673 13.3335 14.1673Z"
                        stroke="#344054"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1.66683 2.50065C2.12707 2.50065 2.50016 2.12755 2.50016 1.66732C2.50016 1.20708 2.12707 0.833984 1.66683 0.833984C1.20659 0.833984 0.833496 1.20708 0.833496 1.66732C0.833496 2.12755 1.20659 2.50065 1.66683 2.50065Z"
                        stroke="#344054"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1.66683 8.33398C2.12707 8.33398 2.50016 7.96089 2.50016 7.50065C2.50016 7.04041 2.12707 6.66732 1.66683 6.66732C1.20659 6.66732 0.833496 7.04041 0.833496 7.50065C0.833496 7.96089 1.20659 8.33398 1.66683 8.33398Z"
                        stroke="#344054"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1.66683 14.1673C2.12707 14.1673 2.50016 13.7942 2.50016 13.334C2.50016 12.8737 2.12707 12.5007 1.66683 12.5007C1.20659 12.5007 0.833496 12.8737 0.833496 13.334C0.833496 13.7942 1.20659 14.1673 1.66683 14.1673Z"
                        stroke="#344054"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <p className="text-md text-semibold">{department.title}</p>
                  </div>

                  <div className="flex items-center gap-8">
                    {canEditDepartment ? (
                      <p
                        className="text-sm text-semibold cursor-pointer"
                        onClick={() =>
                          navigateToEditDepartment("/admin/settings/departments/department/" + String(department.id))
                        }
                      >
                        {t("Edit")}
                      </p>
                    ) : null}
                    <p
                      className="cursor-pointer"
                      style={{ fontSize: "14px" }}
                      onClick={() => handleDepartmentSelect(department)}
                    >
                      <FontAwesomeIcon icon={department.selected ? chevronDown : chevronUp} />
                    </p>
                  </div>
                </div>

                {/* Map through categories */}
                {department.selected ? (
                  <div>
                    {department.cateogries?.map((category: any, index: number) => {
                      return (
                        <React.Fragment key={index}>
                          <div key={index} className="category-card">
                            <div className="flex items-center gap-8">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15px"
                                height="15px"
                                viewBox="0 0 15 15"
                                fill="none"
                              >
                                <path
                                  d="M7.50016 2.50065C7.9604 2.50065 8.3335 2.12755 8.3335 1.66732C8.3335 1.20708 7.9604 0.833984 7.50016 0.833984C7.03993 0.833984 6.66683 1.20708 6.66683 1.66732C6.66683 2.12755 7.03993 2.50065 7.50016 2.50065Z"
                                  stroke="#344054"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M7.50016 8.33398C7.9604 8.33398 8.3335 7.96089 8.3335 7.50065C8.3335 7.04041 7.9604 6.66732 7.50016 6.66732C7.03993 6.66732 6.66683 7.04041 6.66683 7.50065C6.66683 7.96089 7.03993 8.33398 7.50016 8.33398Z"
                                  stroke="#344054"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M7.50016 14.1673C7.9604 14.1673 8.3335 13.7942 8.3335 13.334C8.3335 12.8737 7.9604 12.5007 7.50016 12.5007C7.03993 12.5007 6.66683 12.8737 6.66683 13.334C6.66683 13.7942 7.03993 14.1673 7.50016 14.1673Z"
                                  stroke="#344054"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M13.3335 2.50065C13.7937 2.50065 14.1668 2.12755 14.1668 1.66732C14.1668 1.20708 13.7937 0.833984 13.3335 0.833984C12.8733 0.833984 12.5002 1.20708 12.5002 1.66732C12.5002 2.12755 12.8733 2.50065 13.3335 2.50065Z"
                                  stroke="#344054"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M13.3335 8.33398C13.7937 8.33398 14.1668 7.96089 14.1668 7.50065C14.1668 7.04041 13.7937 6.66732 13.3335 6.66732C12.8733 6.66732 12.5002 7.04041 12.5002 7.50065C12.5002 7.96089 12.8733 8.33398 13.3335 8.33398Z"
                                  stroke="#344054"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M13.3335 14.1673C13.7937 14.1673 14.1668 13.7942 14.1668 13.334C14.1668 12.8737 13.7937 12.5007 13.3335 12.5007C12.8733 12.5007 12.5002 12.8737 12.5002 13.334C12.5002 13.7942 12.8733 14.1673 13.3335 14.1673Z"
                                  stroke="#344054"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M1.66683 2.50065C2.12707 2.50065 2.50016 2.12755 2.50016 1.66732C2.50016 1.20708 2.12707 0.833984 1.66683 0.833984C1.20659 0.833984 0.833496 1.20708 0.833496 1.66732C0.833496 2.12755 1.20659 2.50065 1.66683 2.50065Z"
                                  stroke="#344054"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M1.66683 8.33398C2.12707 8.33398 2.50016 7.96089 2.50016 7.50065C2.50016 7.04041 2.12707 6.66732 1.66683 6.66732C1.20659 6.66732 0.833496 7.04041 0.833496 7.50065C0.833496 7.96089 1.20659 8.33398 1.66683 8.33398Z"
                                  stroke="#344054"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M1.66683 14.1673C2.12707 14.1673 2.50016 13.7942 2.50016 13.334C2.50016 12.8737 2.12707 12.5007 1.66683 12.5007C1.20659 12.5007 0.833496 12.8737 0.833496 13.334C0.833496 13.7942 1.20659 14.1673 1.66683 14.1673Z"
                                  stroke="#344054"
                                  strokeWidth="1.66667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>

                              <p className="text-sm text-medium">{category.title}</p>
                            </div>

                            <div className="flex items-center gap-8">
                              {canEditDepartment ? (
                                <p
                                  className="text-sm text-semibold cursor-pointer"
                                  onClick={() =>
                                    navigateToEditDepartment(
                                      "/admin/settings/departments/category/" + String(category.id),
                                    )
                                  }
                                >
                                  {t("Edit")}
                                </p>
                              ) : null}

                              <p
                                className="cursor-pointer"
                                style={{ fontSize: "14px" }}
                                onClick={() => handleDepartmentSelect(department, category)}
                              >
                                <FontAwesomeIcon icon={category.selected ? chevronDown : chevronUp} />
                              </p>
                            </div>
                          </div>

                          {category.selected ? (
                            <div>
                              {category.subcategories?.map((subcategory: any, index: number) => {
                                return (
                                  <div key={index} className="subcategory-card">
                                    <div className="flex items-center gap-8">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="15px"
                                        height="15px"
                                        viewBox="0 0 15 15"
                                        fill="none"
                                      >
                                        <path
                                          d="M7.50016 2.50065C7.9604 2.50065 8.3335 2.12755 8.3335 1.66732C8.3335 1.20708 7.9604 0.833984 7.50016 0.833984C7.03993 0.833984 6.66683 1.20708 6.66683 1.66732C6.66683 2.12755 7.03993 2.50065 7.50016 2.50065Z"
                                          stroke="#344054"
                                          strokeWidth="1.66667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M7.50016 8.33398C7.9604 8.33398 8.3335 7.96089 8.3335 7.50065C8.3335 7.04041 7.9604 6.66732 7.50016 6.66732C7.03993 6.66732 6.66683 7.04041 6.66683 7.50065C6.66683 7.96089 7.03993 8.33398 7.50016 8.33398Z"
                                          stroke="#344054"
                                          strokeWidth="1.66667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M7.50016 14.1673C7.9604 14.1673 8.3335 13.7942 8.3335 13.334C8.3335 12.8737 7.9604 12.5007 7.50016 12.5007C7.03993 12.5007 6.66683 12.8737 6.66683 13.334C6.66683 13.7942 7.03993 14.1673 7.50016 14.1673Z"
                                          stroke="#344054"
                                          strokeWidth="1.66667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M13.3335 2.50065C13.7937 2.50065 14.1668 2.12755 14.1668 1.66732C14.1668 1.20708 13.7937 0.833984 13.3335 0.833984C12.8733 0.833984 12.5002 1.20708 12.5002 1.66732C12.5002 2.12755 12.8733 2.50065 13.3335 2.50065Z"
                                          stroke="#344054"
                                          strokeWidth="1.66667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M13.3335 8.33398C13.7937 8.33398 14.1668 7.96089 14.1668 7.50065C14.1668 7.04041 13.7937 6.66732 13.3335 6.66732C12.8733 6.66732 12.5002 7.04041 12.5002 7.50065C12.5002 7.96089 12.8733 8.33398 13.3335 8.33398Z"
                                          stroke="#344054"
                                          strokeWidth="1.66667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M13.3335 14.1673C13.7937 14.1673 14.1668 13.7942 14.1668 13.334C14.1668 12.8737 13.7937 12.5007 13.3335 12.5007C12.8733 12.5007 12.5002 12.8737 12.5002 13.334C12.5002 13.7942 12.8733 14.1673 13.3335 14.1673Z"
                                          stroke="#344054"
                                          strokeWidth="1.66667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M1.66683 2.50065C2.12707 2.50065 2.50016 2.12755 2.50016 1.66732C2.50016 1.20708 2.12707 0.833984 1.66683 0.833984C1.20659 0.833984 0.833496 1.20708 0.833496 1.66732C0.833496 2.12755 1.20659 2.50065 1.66683 2.50065Z"
                                          stroke="#344054"
                                          strokeWidth="1.66667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M1.66683 8.33398C2.12707 8.33398 2.50016 7.96089 2.50016 7.50065C2.50016 7.04041 2.12707 6.66732 1.66683 6.66732C1.20659 6.66732 0.833496 7.04041 0.833496 7.50065C0.833496 7.96089 1.20659 8.33398 1.66683 8.33398Z"
                                          stroke="#344054"
                                          strokeWidth="1.66667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M1.66683 14.1673C2.12707 14.1673 2.50016 13.7942 2.50016 13.334C2.50016 12.8737 2.12707 12.5007 1.66683 12.5007C1.20659 12.5007 0.833496 12.8737 0.833496 13.334C0.833496 13.7942 1.20659 14.1673 1.66683 14.1673Z"
                                          stroke="#344054"
                                          strokeWidth="1.66667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      <p className="text-sm text-regular">{subcategory.title}</p>
                                    </div>

                                    {canEditDepartment ? (
                                      <div className="flex items-center gap-8">
                                        <p
                                          className="text-sm text-semibold cursor-pointer"
                                          onClick={() =>
                                            navigateToEditDepartment(
                                              "/admin/settings/departments/subcategory/" + String(subcategory.id),
                                            )
                                          }
                                        >
                                          {t("Edit")}
                                        </p>
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              })}
                            </div>
                          ) : null}
                        </React.Fragment>
                      );
                    })}
                  </div>
                ) : null}
              </React.Fragment>
            );
          })}
      </div>
    </Page>
  );
}
